import Phaser from 'phaser';
import { language } from './language';
import { CST } from '../CST';

var clickSound;

export default class Testimonial extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.TESTIMONIAL);
	}

	preload() {
		this.load.video('video', 'assets/english/Video/Recharge Intro The Inside Edition.mp4');
		this.load.video('video-iOs', 'assets/english/Video/Recharge-Intro-The-Inside-Edition.m4v');
		this.load.image('bg-testimonial', 'assets/english/Video/testimonial-screen.png');
		this.load.image('back_btn', 'assets/english/go-backwards.png');
	}

	create(data) {
		clickSound = this.sound.add('clickSound');
		this.add.image(
			this.cameras.main.width / 2,
			this.cameras.main.height / 2,
			'bg-testimonial' + language,
		);
		this.videoPlaying = true;

		if (/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
			this.video = this.add.video(1153.5, 465, 'video-iOs').setScale(0.425);
		} else {
			this.video = this.add.video(1153.5, 465, 'video').setScale(0.425);
		}

		this.video
			.play()
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				if (this.videoPlaying === true) {
					this.video.stop();
					this.videoPlaying = false;
				} else {
					this.video.play();
					this.videoPlaying = true;
				}
			});
		this.add
			.image(
				this.cameras.main.width / 2 - 665,
				this.cameras.main.height / 2 - 400,
				'back_btn' + language,
			)
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				clickSound.play();
				this.scene.stop();
				this.scene.resume(data.scene, {
					data: 5,
				});
			});
	}
}
